import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface EventsData {
    type: any;
    payload: any;
}

@Injectable()
export class EventsService {
    private readonly events$: Observable<EventsData>;
    private readonly eventsSubject$ = new Subject<EventsData>();

    public constructor() {
        this.events$ = this.eventsSubject$.asObservable();
    }

    public onEvent(type: any) {
        return this.events$.pipe(filter((event) => event.type === type));
    }

    public dispatch(type: any, payload?: any) {
        this.eventsSubject$.next({
            type,
            payload,
        });
    }
}
